import { Label, TextOrHTML } from "@simplybusiness/mobius";
import type { QuestionLabelProps } from "./QuestionFactory";

export const QuestionLabel = ({
  primaryText,
  secondaryText,
  tertiaryText,
  labelClasses,
  labelElementType,
  labelProps,
  secondaryTextId,
  tertiaryTextId,
}: QuestionLabelProps) => {
  const secondaryTextComponent =
    !!secondaryText &&
    (typeof secondaryText === "string" ? (
      <TextOrHTML
        id={secondaryTextId}
        htmlClassName="mobius-question__secondary-text"
        text={secondaryText}
        autoDetect
      />
    ) : (
      secondaryText
    ));

  const tertiaryTextComponent = !!tertiaryText && (
    <TextOrHTML
      id={tertiaryTextId}
      htmlClassName="mobius-question__tertiary-text"
      text={tertiaryText}
      autoDetect
    />
  );

  return (
    <>
      <Label
        className={labelClasses}
        elementType={labelElementType}
        {...labelProps}
      >
        <TextOrHTML text={primaryText} />
      </Label>
      {secondaryTextComponent}
      {tertiaryTextComponent}
    </>
  );
};
